const heroHeading = 'Your Offer is Ready';
const heroHeadingError = 'Oops, something went wrong';
const heroHeadingEstimate = 'Your Estimate is Ready';
const heroHeadingExpired = 'Your Offer has Expired';
const heroHeadingStumped = 'You’ve Stumped Us';
const heroHeadingNotDrivable = 'Ah, Bummer!';
const heroSubheading = 'We’d love to buy your car. Let’s get started.';
const heroSubheadingExpired =
  'We’re still interested in buying your car! Update your mileage below';
const heroSubheadingManual =
  'We’d love to make you an offer, but first we need input from one of our appraisal experts.';
const heroSubheadingRefreshed =
  'Thanks! Your offer has been renewed and is good for another 7 days.';
const heroSubheadingTrade = 'We’ll help you trade in your old car and get you into a new one.';
const heroSubheadingVeryExpired = 'We’re still interested in buying your car!';
const heroSubheadingLowValue =
  'It seems your vehicle is a little outside our sweet spot. You’ve still got options.';
const heroSubheadingNotDrivable =
  'We’d love to make you an offer, but your vehicle must be drivable.';

export {
  heroHeading,
  heroHeadingError,
  heroHeadingEstimate,
  heroHeadingExpired,
  heroHeadingStumped,
  heroHeadingNotDrivable,
  heroSubheading,
  heroSubheadingExpired,
  heroSubheadingManual,
  heroSubheadingLowValue,
  heroSubheadingRefreshed,
  heroSubheadingTrade,
  heroSubheadingVeryExpired,
  heroSubheadingNotDrivable
};
